import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Toast {
	type: string,
	data: any[]
}

@Injectable()
export class ToastService {
	toasts: Toast[] = [];

	/** Emits when user clicks 'Rapporter feil' in a toast */
	reportBugRequested = new Subject<void>();

	remove(toast: Toast) {
		this.toasts = this.toasts.filter(t => t != toast);
	}

	show(toast: Toast) {
		this.toasts.push(toast);
	}

	/** Show error toast with API errorMessage if available, otherwise fallback message */
	showApiError(apiErrorMessages: any[] | undefined | null, fallbackMessage: string): void {
		this.show({
			type: 'error',
			data: apiErrorMessages?.length ? apiErrorMessages : [fallbackMessage]
		});
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}

	requestBugReport(): void {
		this.reportBugRequested.next();
	}
}